export default __webpack_public_path__ + "static/media/AT003.ecae29d2.mp3";